import gql from "graphql-tag";

export const GET_BENEFITS_AVAILAIBILITY_BY_CMS_IDENTIFIER = gql`
  query GetBenefitAvailabilityInfoByCMSIdentifier(
    $user_subscription_id: String!
    $cms_identifier: String!
  ) {
    GetBenefitAvailabilityInfoByCMSIdentifier(
      user_subscription_id: $user_subscription_id
      cms_identifier: $cms_identifier
    ) {
      response
    }
  }
`;

export const CREATE_USER_SUBSCRIPTION_TRANSACTION = gql`
  mutation CreateUserSubscriptionTransactions(
    $UserSubscriptionTransactions: CreateUserSubscriptionTransactionsInput!
  ) {
    CreateUserSubscriptionTransactions(
      UserSubscriptionTransactions: $UserSubscriptionTransactions
    ) {
      success
    }
  }
`;

export const COLLECT_USER_VACCINE_RESPONSE = gql`
  mutation CollectUserVaccineResponse(
    $CreateUserVaccineResponseInput: CreateUserVaccineResponseInput!
  ) {
    CollectUserVaccineResponse(
      UserVaccineResponse: $CreateUserVaccineResponseInput
    ) {
      success
    }
  }
`;

export const GET_ALL_USER_SUBSCRIPTIONS_WITH_BENEFITS_V1 = gql`
  query GetAllUserSubscriptionsWithPlanBenefits(
    $mobile_number: String!
    $status: [String!]!
  ) {
    GetAllUserSubscriptionsWithPlanBenefits(
      mobile_number: $mobile_number
      status: $status
    ) {
      code
      message
      success
      subscriptions {
        _id
        status
        renewNow
        sub_plan_id
        end_date
        aggregated_end_date
        payment_reference
        group_plan {
          name
          plan_id
          meta {
            is_corporate_plan
          }
          group {
            name
          }
        }
        membership_card_details
        benefits {
          header_content
        }
        invoice_url
      }
    }
  }
`;

export const GET_PLAN_BENEFITS = gql`
  query GetPlanDetailsByPlanId($plan_id: String!) {
    GetPlanDetailsByPlanId(plan_id: $plan_id) {
      message
      response {
        name
        benefits {
          description
          header_content
          icon
        }
      }
    }
  }
`;

export const GET_USER_SUBSCRIPTION_DETAILS_BY_ID = gql`
  query GetAllUserSubscriptionsById(
    $plan_id: String!
    $mobile_number: String!
    $user_subscription_id: String
  ) {
    GetAllUserSubscriptionsById(
      plan_id: $plan_id
      mobile_number: $mobile_number
      user_subscription_id: $user_subscription_id
    ) {
      message
      response {
        _id
        plan_id
        expires_in
        end_date
        start_date
        source_meta_data
        renewNow
        payment_reference
        order_id
        sub_plan_id
        savings {
          totalSavings
          benefits {
            attribute
            attribute_type
          }
          savings {
            pharma
            consult
            delivery
            diagnostics
          }
        }
        status
        benefits {
          _id
          icon
          description
          cta_label
          cta_action
          header_content
          remaining
          attribute
          attribute_category
          consumed
        }
        group_plan {
          plan_summary
          group {
            name
          }
          meta {
            landing_page_meta_data
          }
        }
      }
    }
  }
`;
